import { isEmpty, isUndefined } from 'lodash'
import moment from 'moment'

export const getDateRuleString = ({
  value,
  defaultValue = 'TODAY',
  deltaDefault = 0,
  dateFormat = 'DD-MM-YYYY',
  isScheduledMode
}) => {
  if (!isScheduledMode) return ''
  const ruleDate = getDayByDeltaValue(defaultValue, deltaDefault)

  const momentRuleDate = moment(ruleDate)
  const momentChoosenDate = moment(value, dateFormat)

  const diffDays = momentChoosenDate
    .startOf('day')
    .diff(momentRuleDate.startOf('day'), 'days')

  const diffDaysLabel =
    diffDays === 0 ? '' : diffDays > 0 ? ` +${diffDays}` : ` ${diffDays}`

  if (deltaDefault !== 0) {
    return `[${defaultValue} ${deltaDefault}]${diffDaysLabel}`
  } else {
    return `[${defaultValue}]${diffDaysLabel}`
  }
}

export const getDateISO = (
  date,
  separator = '-',
  isScheduledMode,
  payloadMapper,
  elementId
) => {
  const event = new Date(date)
  const year = event.getFullYear()
  const month = `${event.getMonth() + 1}`.padStart(2, '0')
  const day = `${event.getDate()}`.padStart(2, '0')
  const dateResult = [year, month, day].join(separator)

  let result = `${dateResult} `
  if (isScheduledMode) {
    const ruleString = payloadMapper[elementId]
    result += ruleString
  }

  return result?.trim()
}

export const getDateTimeISO = (date, type = 'date') => {
  const event = new Date(date)
  const minutes = `${event.getMinutes()}`.padStart(2, '0')
  const hours = `${event.getHours()}`.padStart(2, '0')
  // const seconds = `${event.getSeconds()}`.padStart(2, '0')

  const yyyyMmDd = getDateISO(date)

  if (type === 'date') return yyyyMmDd

  // return `${yyyyMmDd} ${hours}:${minutes}:${seconds}`
  return `${yyyyMmDd} ${hours}:${minutes}`
}

export const formatDay = (type, times) => {
  const date = moment(datesMap[type]).utc().toDate()
  date.setHours(times.hours)
  date.setMinutes(times.minutes)
  date.setSeconds(times.seconds)
  return date
}

export const getDayByDeltaValue = (day, delta, times) => {
  if (datesMap[day]) {
    const recalculatedDay = moment(datesMap[day]).add(delta, 'days')
    const formattedDate = moment(recalculatedDay)
    const date = moment(formattedDate).utc().toDate()
    if (!isEmpty(times)) {
      date.setHours(times.hours)
      date.setMinutes(times.minutes)
      date.setSeconds(times.seconds)
    }
    return date
  } else return undefined
}

export const getDayOfWeek = (dayNumber) => {
  const today = moment()
  const day = today.clone().weekday(dayNumber)
  return moment(day)
}

export const datesMap = {
  TODAY: moment(),
  FIRST_DAY_OF_WEEK: getDayOfWeek(1),
  LAST_DAY_OF_WEEK: getDayOfWeek(7),
  FIRST_DAY_OF_MONTH: moment().startOf('month'),
  LAST_DAY_OF_MONTH: moment().endOf('month')
}

export const timesMin = {
  hours: '00',
  minutes: '00',
  seconds: '00'
}

export const timesMax = {
  hours: '23',
  minutes: '59',
  seconds: '59'
}

export const getDefaultDate = (value, deltaDefault, defaultValue) => {
  if (value === '') {
    return moment().format('YYYY-MM-DD HH:mm')
  } else {
    if (isUndefined(deltaDefault)) {
      return moment(datesMap[defaultValue]).utc().toDate()
    } else {
      return getDayByDeltaValue(defaultValue, deltaDefault)
    }
  }
}
